module.exports = __webpack_public_path__ + "img/02-title-02.482c8ade.png";